// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

type CoaPayload = {
  coa_buy_code: string
  coa_buy_name: string
  coa_sell_code: string
  coa_sell_name: string
  coa_inv_code: string
  coa_inv_name: string
}

export function useCoaItem(product_id:string): {
  data: CoaPayload | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<CoaPayload | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get("/probill/coabsi_byproduct", {
      params: { product_id }
    })
      .then((res: SuccessFetch<{ payload: CoaPayload }>) => {
        setData(res.data.payload)
      })
      .catch(() => {
        setData(null)
      })
      .finally(() => {
        setLoading(false)
      })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { isLoading, data }
}